import {makeStyles} from '@material-ui/core/styles'
import {Text} from '../../../1elements'
import {formatDate} from '../../../../services/util/formatter'

const ConversationHistoryView = ({admin, index, data, commentList}) => {
    const classes = useStyles({admin})

    if(commentList.length === 0){
        return(
            <div className={classes.innerDiv}>
                <Text>No conversation yet</Text>
            </div>
        )
    }

    return (
        <div className={classes.innerDiv}>
            {
                commentList.map((conversation)=>(
                    <div key={conversation.id} className={classes.messageRow}>
                        <Text type={'p'} className={classes.date}>{formatDate(conversation.created_at)}:</Text>
                        <Text type={'p'}>{conversation.dashboard_comment}</Text>
                    </div>
                ))
            }
        </div>
    )
}

export default ConversationHistoryView

const useStyles = makeStyles((theme)=>({
    innerDiv: {
        overflowY: 'auto',
        padding: '0 0 0 30px',
        maxHeight: 150,
        marginTop: 20
    },
    messageRow: {
        display: 'grid',
        gridTemplateColumns: '1fr 3fr',
        gap: 5,
        marginBottom: 10
    },
    date: {
    },
}))